<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title
        :title="$t('message.aside.infoloc', { value: 'default' })"
      ></portal-title>
      <portal-breadcumb></portal-breadcumb>
      <div class="content"></div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
//import MaximoService from "@/services/MaximoService";
//import { formatMagicDate } from "@/shared/DateHelper";

export default {
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
  },
};
</script>
